import { api } from 'services/companiesApi';

export const getGuideCampaigns = (id: string, filters: any) =>
	api.get(`/campaigns/${id}/questionnaires-progress`, { params: filters });
